import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IMerchant, IMerchantListData } from './types';

export const fetchMerchantsRequest = async ({ page, size, ...data }: IQueryParams): Promise<IMerchantListData | null> => {
  try {
    const res = await axios.post(`api/v1/merchants`, data, { params: { page, size } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch merchants");
    return null;
  }
};

export const fetchMerchantByIdRequest = async (id: string): Promise<IMerchant | null> => {
  try {
    const res = await axios.get(`api/v1/merchants/${id}`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch account ${id}`);
    return null;
  }
};

export const fetchMerchantCreateRequest = async (data: Partial<IMerchant>): Promise<IMerchant | null> => {
  try {
    const res = await axios.put('api/v1/merchants', data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't create merchant`);
    return null;
  }
};

export const fetchMerchantUpdateRequest = async (id: number, data: Partial<IMerchant>): Promise<IMerchant | null> => {
  try {
    const res = await axios.post(`api/v1/merchants/${id}`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't update merchant`);
    return null;
  }
};
